
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("eys5O"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("eys5O", function(module, exports) {

let $a98a084df59cb881$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a98a084df59cb881$var$load("h3ABO"),
    $a98a084df59cb881$var$load("9hYRW"),
    $a98a084df59cb881$var$load("kpm7S"),
    $a98a084df59cb881$var$load("kc8tx"),
    $a98a084df59cb881$var$load("2YffH"),
    $a98a084df59cb881$var$load("g7ggm"),
    $a98a084df59cb881$var$load("eEyVs"),
    $a98a084df59cb881$var$load("6mHrv"),
    $a98a084df59cb881$var$load("awWN9"),
    $a98a084df59cb881$var$load("9CYct"),
    $a98a084df59cb881$var$load("dvaCT"),
    $a98a084df59cb881$var$load("dLE56"),
    $a98a084df59cb881$var$load("hZtKG"),
    $a98a084df59cb881$var$load("dkqvW"),
    $a98a084df59cb881$var$load("lVO3w"),
    $a98a084df59cb881$var$load("hyzoX"),
    $a98a084df59cb881$var$load("h9Ed7"),
    $a98a084df59cb881$var$load("eBRUf"),
    $a98a084df59cb881$var$load("kbRvk"),
    $a98a084df59cb881$var$load("tKhaz"),
    $a98a084df59cb881$var$load("hwT9D"),
    $a98a084df59cb881$var$load("j4Bpe"),
    $a98a084df59cb881$var$load("cD6Zr"),
    $a98a084df59cb881$var$load("k3jER"),
    $a98a084df59cb881$var$load("9wzNh"),
    $a98a084df59cb881$var$load("8YSo7"),
    $a98a084df59cb881$var$load("9ldRJ"),
    $a98a084df59cb881$var$load("50ame"),
    $a98a084df59cb881$var$load("7do1E"),
    $a98a084df59cb881$var$load("77dkW"),
    $a98a084df59cb881$var$load("1MlIV"),
    $a98a084df59cb881$var$load("6iz6l"),
    $a98a084df59cb881$var$load("4SCW2"),
    $a98a084df59cb881$var$load("aXHNO"),
    $a98a084df59cb881$var$load("kmvek"),
    $a98a084df59cb881$var$load("Wowvf"),
    $a98a084df59cb881$var$load("421lv"),
    $a98a084df59cb881$var$load("dek7I"),
    $a98a084df59cb881$var$load("3SmkN"),
    $a98a084df59cb881$var$load("dYtBN"),
    $a98a084df59cb881$var$load("kNV5Y"),
    $a98a084df59cb881$var$load("6wr18"),
    $a98a084df59cb881$var$load("kjZZD"),
    $a98a084df59cb881$var$load("7cDV0"),
    $a98a084df59cb881$var$load("ijD5W"),
    $a98a084df59cb881$var$load("3JSgG"),
    $a98a084df59cb881$var$load("37ldp"),
    $a98a084df59cb881$var$load("ffEVr"),
    $a98a084df59cb881$var$load("9AXkC"),
    $a98a084df59cb881$var$load("28arV"),
    $a98a084df59cb881$var$load("hhss7"),
    $a98a084df59cb881$var$load("l1BQC"),
    $a98a084df59cb881$var$load("jlSF3"),
    $a98a084df59cb881$var$load("dP7ao"),
    $a98a084df59cb881$var$load("hogcU"),
    $a98a084df59cb881$var$load("4pqtR"),
    $a98a084df59cb881$var$load("5XqRg"),
    $a98a084df59cb881$var$load("7EorR"),
    $a98a084df59cb881$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.04e78830.js.map
